import React, { useContext } from 'react'

/* import RedeemInput from './RedeemInput' */
import styled, { ThemeContext } from 'styled-components'
import RedeemInput from './RedeemInput'
import IntroCard from 'components/IntroCard'
import { useActiveWeb3React } from 'hooks'
import { TYPE } from 'theme'
import { ButtonPrimary } from 'components/Button'
import Vesting from './Vesting'
import useVestingXToken from 'hooks/useVestingXToken'
import { Helmet } from 'react-helmet'
import { usePrivy } from '@privy-io/react-auth'

const ContainerStyled = styled.div`
  width: 100%;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 200px;
  @media (min-width: 502px) {
    padding: 10px;
  }
`

const ConnectWalletContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  min-height: 25vh;
  background: ${({ theme }) => theme.bg0};
  padding: 8px;
  border-radius: 14px;
  width: 100%;

  div {
    max-width: 300px;
  }
`

const GridContainer = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: calc(55% - 8px) calc(45% - 8px);
  }
`

const SubContainer = styled.div<{ bg1: boolean }>`
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
const SubContainerHeader = styled.div`
  border-radius: 14px; 
  background: ${({ theme }) => theme.bg1}
  padding: 20px;
`
const SubContainerBody = styled.div`
  padding: 20px;
  background: ${({ theme }) => theme.bg0};
  margin: auto 0;
  height: 100%;
`

const RedeemXHSPX = () => {
  const [refresh, setRefresh] = React.useState(false)
  const { account } = useActiveWeb3React()
  const theme = useContext(ThemeContext)
  const { login } = usePrivy()

  const { data: vestingData, refresh: vestingRefresh } = useVestingXToken()

  React.useEffect(() => {
    if (refresh) {
      setRefresh(false)
      vestingRefresh()
    }
  }, [refresh, setRefresh, vestingRefresh])

  const index = Math.floor(Math.random() * 99999)

  return (
    <>
      <Helmet>
        <title>Redeem $xSWAP | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="Convert your $xSWAP tokens back into $SWAP with flexible vesting periods. Redeem at ratios from 1:0.5 over 15 days to 1:1 over 6 months."
        />
        <meta
          name="keywords"
          content="HyperSwap redeem, $xSWAP, $SWAP, token vesting, liquidity redemption, DeFi platform, Hyperliquid"
        />
        <meta property="og:title" content="Redeem $xSWAP | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="Redeem your $xSWAP tokens for $SWAP with customizable vesting options ranging from 15 days to 6 months."
        />
        <meta property="og:url" content={`${window.location.origin}/#/redeem`} />
      </Helmet>
      <ContainerStyled>
        <IntroCard variant={1} Key="Redeem">
          <h1>Redeem your $xSWAP tokens</h1>
          <p>
            Redeem your $xSWAP back into $SWAP over a vesting period of 15 days (1:0.5 ratio) to 6 months (1:1 ratio).
          </p>
        </IntroCard>
        {account ? (
          <>
            <GridContainer>
              <SubContainer bg1={false}>
                <SubContainerHeader>
                  <h2 style={{ fontSize: '16px', marginTop: '0' }}>Redeem $xSWAP</h2>
                  <p style={{ color: 'lightgrey', fontSize: '12px', marginBottom: '0' }}>
                    Redeem your $xSWAP back into $SWAP over a vesting period of 15 days (1:0.5 ratio) to 6 months (1:1
                    ratio).
                  </p>
                </SubContainerHeader>
                <SubContainerBody>
                  <RedeemInput key={index} setRefresh={setRefresh} />
                </SubContainerBody>
              </SubContainer>
              <SubContainer bg1={false}>
                <SubContainerHeader>
                  <h2 style={{ fontSize: '16px', marginTop: '0' }}>Vesting Overview</h2>
                  <p style={{ color: 'lightgrey', fontSize: '12px', marginBottom: '0' }}>
                    Track the progress of your $xSWAP over the selected vesting periods.
                  </p>
                </SubContainerHeader>
                <SubContainerBody>
                  <Vesting data={vestingData} refresh={vestingRefresh} />
                </SubContainerBody>
              </SubContainer>
            </GridContainer>
          </>
        ) : (
          <ConnectWalletContainer>
            <div>
              <TYPE.mediumHeader textAlign="center" color={theme.text3}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-coin"
                  style={{ marginBottom: '.5rem' }}
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1" />
                  <path d="M12 7v10" />
                </svg>
                <div>{'Connect your wallet to redeem your tokens.'}</div>
              </TYPE.mediumHeader>
              <ButtonPrimary
                style={{ marginTop: '2em', padding: '8px 16px' }}
                onClick={() =>
                  login({
                    loginMethods: ['wallet'],
                    walletChainType: 'ethereum-only',
                    disableSignup: false,
                  })
                }
              >
                Connect a wallet
              </ButtonPrimary>
            </div>
          </ConnectWalletContainer>
        )}
      </ContainerStyled>
    </>
  )
}
export default RedeemXHSPX
